import css from "../gantt.module.scss";

type HorizontalLinesProps = {
  rowHeights: number[];
};

const getRowPositions = (rowHeights: number[]) => {
  let top = 0;
  return rowHeights.map((rh) => {
    top += rh;
    return top;
  });
};

export const HorizontalLines = ({ rowHeights }: HorizontalLinesProps) => (
  <div>
    {getRowPositions(rowHeights).map((top) => (
      <div key={top} className={css.horizontalLine} style={{ top }} />
    ))}
  </div>
);
